import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=0344b1bb&scoped=true&"
import script from "./ChatBox.vue?vue&type=script&lang=js&"
export * from "./ChatBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=0344b1bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344b1bb",
  null
  
)

export default component.exports